import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IDropdownOption } from '../mat-dropdown/mat-dropdown.component';
import {
  EItemPriority,
  getItemPriorityTranslationKey,
  IItemPriorityStyle,
  itemPriorityOrder,
  itemPriorityStyle,
} from './item-priority.interface';

@Injectable({ providedIn: 'root' })
export class ItemPriorityService {
  constructor(private readonly translate: TranslateService) {}

  public getOptions(): IDropdownOption<EItemPriority>[] {
    return itemPriorityOrder.map((priority: EItemPriority) => this.getOption(priority));
  }

  public getOption(priority: EItemPriority): IDropdownOption<EItemPriority> {
    const style: IItemPriorityStyle = itemPriorityStyle[priority];

    return {
      icon: style.icon,
      iconColor: style.color,
      id: priority,
      name: this.translate.instant(getItemPriorityTranslationKey(priority)),
    };
  }
}
